<template>
    <SwipeModalComponent v-if="dependentRegisterMenu.isVisible" @closeMenu="changeDependentMenuVisibility">
        <div class="content-wrapper">
            <h2 v-text="'Adicionar Dependente'"></h2>

            <div class="menu-fields-container">
                <InputContainer :inputs="dependentRegisterMenu.inputs" ref="dependentInfo" />
            </div>

            <div class="confirmButton">
                <button @click="addDependent">Confirmar</button>
            </div>
        </div>
    </SwipeModalComponent>
</template>
<script >
import SwipeModalComponent from './SwipeModalComponent.vue'
import InputContainer from '../inputs/InputContainer.vue'
import { showErrorNotification } from '@/libs/Util.js'
import { getEnv } from '@/libs/Environment.js'
import { mapGetters, mapActions } from 'vuex'

const usaRAAutomatico = getEnv().usa_registro_academico_automatico === 'S'

export default {
    name: 'DependentRegisterComponent',
    emits: ['addDependent'],
    components: {
        InputContainer,
        SwipeModalComponent
    },
    data () {
        return {
            error: false,
            messages: []
        }
    },
    computed: {
        ...mapGetters(['dependentRegisterMenu'])
    },
    methods: {
        ...mapActions(['changeDependentMenuVisibility']),
        addDependent () {
            const depInfo = this.$refs.dependentInfo.getValues()
            this.validadeValues(depInfo)

            if (!this.error) {
                const dependent = {
                    nome: depInfo.find(i => i.key === 'dependent_name')?.value
                }

                if (!usaRAAutomatico) {
                    dependent.ra = depInfo.find(i => i.key === 'academic_register')?.value
                }

                this.changeDependentMenuVisibility()
                this.$emit('addDependent', dependent)
            } else {
                this.messages.forEach(e => {
                    showErrorNotification({
                        title: '',
                        text: e
                    })
                })
                this.messages = []
            }
        },
        validadeValues: function (depInfo) {
            this.error = false
            depInfo.forEach(element => {
                if (
                    element.required &&
                    (!element.value) &&
                    (usaRAAutomatico ? element.key !== 'academic_register' : true)
                ) {
                    const message = `O campo ${element.display} deve ser preenchido.`
                    this.messages.push(message)
                    this.error = true
                }
            })
        }
    }
}
</script>
<style lang="less" scoped>
.content-wrapper {
    max-width: 100%;
    h2 {
        text-align: center;
        margin-bottom: 40px;
    }
    .menu-fields-container {
        padding: 0 15px;
        overflow: auto;
        margin-bottom: 30px;
    }

    .confirmButton {
        width: 100%;
        display: flex;
        justify-content: flex-end;
    }

    button {
        text-align: right;
        border-radius: 5px;
        color: var(--buttonText);
        padding: 10px;
        margin: 0px 15px 20px 15px;
        font-weight: 600;
        border: none;
        background-color: var(--buttonBackground);
    }
}
</style>
